import { AxiosError } from 'axios';
import { isNil } from 'lodash';

import { ErrorCodes, ErrorMessages } from '@enums/error';

interface ErrorResponseData {
  header?: string;
  message?: string;
  msg?: string;
  code?: string;
}

export const getErrorMessage = (error: AxiosError) => {
  const { response, status } = error || {};
  const { data } = response || {};
  const { message, code } = (data || {}) as ErrorResponseData;

  if (
    status &&
    status === 401 &&
    (code === ErrorCodes.INACTIVE_TOKEN || code === ErrorCodes.INACTIVE_CLIENT)
  ) {
    return ErrorMessages.APP_SESSION_EXPIRED;
  }

  if (!isNil(message)) {
    return message;
  }

  return ErrorMessages.DEFAULT;
};
